const normalizeHostname = (value: string): string =>
  value.replace(/^www\./, '').toLowerCase();

const parseDomain = (domain: string): { hostname: string; port?: string } => {
  const value = domain.trim();
  const colonIndex = value.lastIndexOf(':');

  if (colonIndex === -1) {
    return { hostname: value };
  }

  const port = value.slice(colonIndex + 1);

  if (!/^\d+$/.test(port)) {
    return { hostname: value };
  }

  return {
    hostname: value.slice(0, colonIndex),
    port
  };
};

const getEffectivePagePort = (): string => {
  if (window.location.port) {
    return window.location.port;
  }

  return window.location.protocol === 'https:' ? '443' : '80';
};

const isHostnameMatch = (
  pageHostname: string,
  channelHostname: string
): boolean => {
  const page = normalizeHostname(pageHostname);
  const channel = normalizeHostname(channelHostname);

  if (!channel) {
    return false;
  }

  return page === channel || page.endsWith(`.${channel}`);
};

/**
 * Checks whether the channel domain matches the current page host.
 * When the channel includes a port, it must match the effective page port.
 * When the channel omits a port, any page port is accepted.
 * Supports subdomains and www normalization.
 */
export const isCurrentDomain = (domain: string): boolean => {
  if (!domain) {
    return false;
  }

  const { hostname: channelHostname, port: channelPort } = parseDomain(domain);

  if (channelPort !== undefined && channelPort !== getEffectivePagePort()) {
    return false;
  }

  return isHostnameMatch(window.location.hostname, channelHostname);
};
